import { toast } from "react-toastify";

const dtoToViewFilterArray = (dtoArray, initialObject) => {
  if (!dtoArray) return [initialObject];
  else if (Array.isArray(dtoArray)) {
    if (dtoArray.length === 0) return [initialObject];
    else {
      if (dtoArray[0]?.id) return dtoArray;
      else return [initialObject];
    }
  } else {
    toast.error("something went wrong in *dtoToViewFilterArray* call PNG");
  }
};

export default dtoToViewFilterArray;
